import { render, staticRenderFns } from "./product-select-table.vue?vue&type=template&id=c9460d60&"
import script from "./product-select-table.vue?vue&type=script&lang=js&"
export * from "./product-select-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-select-table.vue"
export default component.exports